/**
 * Jul-2026 (User-Wunsch) — AGB-/Datenschutz-Bestätigung für ALLE kundenseitigen
 * Mobil-/Public-Portale. Zwei Pflicht-Checkboxen; die Hauptaktion des Portals
 * bleibt gesperrt, bis beide bestätigt sind. Die Zustimmung wird einmalig
 * serverseitig protokolliert (POST /api/public/legal-consent).
 *
 * Links zeigen auf die Händler-Dokumente (falls übergeben), sonst auf die
 * TwoWheels-Standardseiten (/agb, /datenschutz).
 */
import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicLegalConsent({
    token,
    portal,
    agbUrl,
    datenschutzUrl,
    onAcceptedChange,
    accent = "#111827",
    className = "",
}) {
    const [agb, setAgb] = useState(false);
    const [ds, setDs] = useState(false);
    const logged = useRef(false);
    const accepted = agb && ds;

    useEffect(() => {
        onAcceptedChange?.(accepted);
    }, [accepted, onAcceptedChange]);

    useEffect(() => {
        if (accepted && !logged.current) {
            logged.current = true;
            axios.post(`${API}/public/legal-consent`, {
                token: token || "",
                portal,
                agb: true,
                datenschutz: true,
            }).catch(() => { /* Protokoll best-effort — blockiert den Kunden nicht */ });
        }
    }, [accepted, token, portal]);

    const AGB = agbUrl || "/agb";
    const DS = datenschutzUrl || "/datenschutz";

    return (
        <div className={`rounded-sm border border-gray-200 bg-gray-50 p-3 space-y-2 ${className}`} data-testid="public-legal-consent">
            <label className="flex items-start gap-2.5 cursor-pointer text-sm text-gray-700 leading-snug">
                <input
                    type="checkbox"
                    checked={agb}
                    onChange={(e) => setAgb(e.target.checked)}
                    className="mt-0.5 w-4 h-4 shrink-0"
                    style={{ accentColor: accent }}
                    data-testid="consent-agb-checkbox"
                />
                <span>
                    Ich akzeptiere die{" "}
                    <a href={AGB} target="_blank" rel="noreferrer" className="underline font-semibold" style={{ color: accent }} data-testid="consent-agb-link">
                        AGB
                    </a>.
                </span>
            </label>
            <label className="flex items-start gap-2.5 cursor-pointer text-sm text-gray-700 leading-snug">
                <input
                    type="checkbox"
                    checked={ds}
                    onChange={(e) => setDs(e.target.checked)}
                    className="mt-0.5 w-4 h-4 shrink-0"
                    style={{ accentColor: accent }}
                    data-testid="consent-datenschutz-checkbox"
                />
                <span>
                    Ich habe die{" "}
                    <a href={DS} target="_blank" rel="noreferrer" className="underline font-semibold" style={{ color: accent }} data-testid="consent-datenschutz-link">
                        Datenschutzerklärung
                    </a>{" "}
                    gelesen.
                </span>
            </label>
        </div>
    );
}
